<div class="partners-page__main">
  <div class="partners-page__title">
    <div class="partners-page-title vox-heading-3" translate>partners.title</div>
    <button (click)="addPartner()" class="vox-btn vox-btn-secondary" translate>partners.actions.create</button>
  </div>
  <vov-partners-table (onDeletePartner)="deletePartner($event)" (onEditPartner)="editPartner($event)" (onAddLink)="addLink($event)"></vov-partners-table>
</div>
